<input
  #fileInput
  jniAutoCompleteBlocker
  type="file"
  id="{{ attachmentLabel }}"
  name="{{ attachmentLabel }}"
  style="display: none"
  (change)="getAttachmentFile($event)" />
<div
  jniGlobalFileDrop
  [maxFileSize]="30"
  [maxFiles]="1"
  (filesDropped)="onAttachmentDropped($event)"
  (filesRejected)="onFilesRejected($event)"
  class="attachment-drop-zone">
  <label
    for="{{ attachmentLabel }}"
    class="d-flex align-items-center"
    (click)="fileInput.click()">
    <i class="icon-Upload me-2"></i> {{ attachmentLabel }}
  </label>
</div>
<span
  class="text-primary small"
  data-toggle="tooltip"
  [title]="attachmentFileName">
  {{ attachmentFileName }}
</span>
